// extracted by mini-css-extract-plugin
export default {"container":"course_container__l8Ds7","mobile":"course_mobile__yoKqI"};